import SubjectList from "@/controllers/subject/subject-list";

export default {
  extends: SubjectList,

  methods: {
    excelImport() {
      this.$router.push({
        name: "subjectImport",
      });
    },
  }
}
